<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="派单人员"
                prop="manageUserId"
                label-width="100px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.manageUserId"
                  placeholder="请选择派单人员"
                >
                  <el-option
                    v-for="item in personList"
                    :key="item.id"
                    :label="item.userName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="状态"
                prop="status"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.status" placeholder="请选择状态">
                  <el-option label="待完成" :value="0"> </el-option>
                  <el-option label="已完成" :value="1"> </el-option>
                  <el-option label="未完成" :value="2"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
        <!-- <el-button
          size="small"
          type="primary"
          style="width: 90px; margin-right: 15px;margin-bottom:15px;"
          icon="el-icon-download"
          @click="downloadUrl"
        >
          导出</el-button
        >     -->
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="完成人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="派单时间" align="center">
        </el-table-column>        
        <el-table-column prop="completeTime" label="完成时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="派单状态" align="center" :formatter="statusList">
        </el-table-column>        
        <el-table-column
          prop="isAbnormal"
          label="是否异常"
          align="center"
          :formatter="isAbnormalList"
        >
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >派单详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="完成人" prop="userName" label-width="100px">
                <el-input
                  v-model="addData.userName"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phone" label-width="100px">
                <el-input
                  v-model="addData.phone"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="派单时间" prop="createTime" label-width="100px">
                <el-input
                  v-model="addData.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>            
            <el-col :span="12">
              <el-form-item
                label="完成日期"
                prop="completeTime"
                label-width="100px"
              >
                <el-input
                  v-model="addData.completeTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
         <el-row>
            <el-col :span="24">
              <el-form-item label="派单内容" prop="content" label-width="100px">
                <el-input
                  v-model="addData.content"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>          
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="完成图片"
                prop="completeImg"
                label-width="100px"
              >
                <img
                  :src="item"
                  @click="seeImg(item)"
                  alt=""
                  v-for="(item, ind) in addData.completeImg &&
                  addData.completeImg.split(',')"
                  :key="ind"
                  width="70px"
                  height="70px"
                  style="margin-right: 10px; cursor: pointer"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="完成详情"
                prop="completeDesc"
                label-width="100px"
              >
                <el-input
                  type="textarea"
                  autosize
                  placeholder="无"
                  disabled
                  v-model="addData.completeDesc"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false" type="primary">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible" style="z-index: 1999">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
export default {
  data() {
    return {
      searchForm: {
        manageUserId: "",
        patrolTime: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      dialogVisible: false,
      dialogImageUrl: "",
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "巡更详情",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      nightPatrolList: [],
      addData: {
        id: "",
        name: "",
        time: "",
      },
      patrolClass: [],
      personList: [],
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      baseUrL:"http://192.168.0.39:5001/device-uphold-record/list-export",
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 导出派单记录
    downloadUrl(){
        var villageId = JSON.parse(localStorage.getItem('park_data')).id
        var {manageUserId,patrolPointId,patrolTime} = this.searchForm
        window.location.href = this.baseUrL + '?villageId=' + villageId + '&manageUserId=' + manageUserId + '&patrolPointId=' + patrolPointId + '&patrolTime=' + reg.filterTime(patrolTime); //文件路径
    },    
    statusList(row){
      if(row.status == 0){
        return "待完成"
      }else if(row.status == 1){
        return "已完成"
      }else if(row.status == 2){
        return "未完成"
      }
    },
    isAbnormalList(row) {
      return row.isAbnormal == 0 ? "无异常" : "有异常";
    },
    // 查看图片
    seeImg(row) {
      this.dialogImageUrl = row;
      this.dialogVisible = true;
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.houseDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            name: this.addData.name.join(),
            time: reg.filterTime(this.addData.time),
          };
          console.log(data);
          return;
          this.$Apis.houseAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        manageUserId: this.searchForm.manageUserId,
        status: this.searchForm.status,
      };
      this.$Apis.manageTotalList().then((res) => {
        if (res.code == 200) {
          this.personList = res.data;
        }
      });
      this.$Apis.dispatchOrderRecordList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>